export default "__VITE_ASSET__CBZwac_D__"